import React, { FC } from 'react';
import LinkedTasks from '../../../../../../clients/sidebar/views/SidebarPanel/Detailbar/LinkedTasks';
import { useLinkedTasks } from 'appJS/views/task_details/useLinkedTasks';
import { DashboardProjectAccess } from './projectContextQueries';
import { DashboardTask } from './queries';

type Props = {
  task: DashboardTask;
  bugherdUrl: string;
  container: HTMLDivElement;
  currentUserRole: string;
  accessTo: DashboardProjectAccess | null;
  onOpenTask?: (taskId: number) => void;
};

export const DrawerLinkedTasks: FC<Props> = ({
  task,
  bugherdUrl,
  container,
  currentUserRole,
  accessTo,
  onOpenTask
}) => {
  const { linkedTasks, loading, error } = useLinkedTasks({
    bugherdUrl,
    projectId: Number(task.project.id),
    activeTask: { id: Number(task.id) },
    isAdminView: true
  });

  if (!accessTo?.viewLinkedTasks) return null;

  return (
    <LinkedTasks
      linkedTasks={linkedTasks}
      viewLinkedTasks={accessTo.viewLinkedTasks}
      loading={loading}
      error={error}
      container={container}
      projectId={Number(task.project.id)}
      bugherdUrl={bugherdUrl}
      isAdminView
      currentUserRole={currentUserRole as any}
      onLinkedTaskSelect={onOpenTask ? id => onOpenTask(id) : undefined}
    />
  );
};
